export function useParams() {
  return useNuxtApp().$params
}
